<template>
  <div style="height:100%;background:#ededed">
    <div class="contain hed100">
      <div class="nav-check-list"
           style="position: fixed;top:0;left: 0;z-index: 11;">
        <p class="ele-nav-checklist"
           style="width:2.4rem"
           :class="type==approveParam.allApprove?selected:''"
           @click="changeType(approveParam.allApprove)">全部可审批<span class="line-nav-checklist"
                v-if="type==approveParam.allApprove"></span></p>
        <p class="ele-nav-checklist"
           style="width:2.4rem"
           :class="type==approveParam.visitReport?selected:''"
           @click="changeType(approveParam.visitReport)">访问报告<span class="line-nav-checklist"
                v-if="type==approveParam.visitReport"></span></p>
        <p class="ele-nav-checklist"
           :class="type==approveParam.customer?selected:''"
           @click="changeType(approveParam.customer)">客户<span class="line-nav-checklist"
                v-if="type==approveParam.customer"></span></p>
        <p class="ele-nav-checklist"
           :class="type==approveParam.invalidReport?selected:''"
           @click="changeType(approveParam.invalidReport)">已过期<span class="line-nav-checklist"
                v-if="type==approveParam.invalidReport"></span></p>
        <van-button plain
                    type="info"
                    style="width:1.54rem;height:0.54rem;padding:0.1rem;margin-left:0.14rem;margin-right:0.24rem;font-size:0.24rem"
                    @click="turnToHome">首页</van-button>
      </div>
      <scroller :on-infinite="infinite"
                :on-refresh="refresh"
                :noDataText="noDataText"
                ref="my_scroller"
                v-if="filterData.length>0">
        <div class="layout-checklist">
          <ApproveItem :item="item"
                       v-for="item in filterData"
                       :key="item.id"></ApproveItem>
        </div>
      </scroller>
      <div class="layout-checklist null-checklist"
           v-if="filterData.length==0">
        <img src="../../assets/images/img-null.png"
             class="img-null">
        <p class="color-gray">暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import approveModel from '../../api/model/approve'
import ApproveItem from '../../components/approve/ApproveItem.vue'
export default {
  name: 'Approve',
  data() {
    return {
      noDataText: '没有数据了',
      type: 0,
      approveArr: [],
      filterData: [],
      pageIndex: 1,
      pageSize: 20,
      selected: 'nac-nav-checklist',
    }
  },
  components: {
    ApproveItem,
  },
  methods: {
    async getDataByType(type) {
      this.type = type
      const res = await approveModel.getPageList({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        type: this.type,
      })
      if (res.success) {
        res.data.forEach((element) => {
            this.approveArr.push(element)
        })
        this.changeType(this.type)
      } else {
        this.$toast(res.msg)
      }
    },
    changeType(type) {
      this.type = type
      if (type != 0) {
        this.filterData = this.approveArr.filter((p) => {
          return p.approveType == type
        })
      } else {
        this.filterData =this.approveArr.filter((p) => {
          return p.approveType != this.approveParam.invalidReport
        })
      }
    },
    infinite: function () {
      this.pageIndex++
      this.$refs.my_scroller.finishInfinite(false)
      this.getDataByType(this.type)
      this.$refs.my_scroller.finishInfinite(true)
    },
    refresh: function () {
      this.approveArr = []
      this.pageIndex = 1
      this.getDataByType(this.type)
      this.$refs.my_scroller.finishPullToRefresh()
    },
    turnToHome() {
      this.$router.push('/home')
    },
  },
  mounted() {
    this.getDataByType(this.approveParam.invalidReport)
    this.getDataByType(this.approveParam.allApprove)
  },
  computed: {
    ...mapState('systemAbout', ['approveParam']),
  },
}
</script>

<style scoped>
</style>